import { getTime } from 'date-fns';
import { debounce } from 'lodash';
import { useCallback } from 'react';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';

import { useAssignBookingRequestMutation, useConfirmBookingRequestMutation } from 'src/api/booking-request-api';
import { refreshKeyConfig } from 'src/config';
import { setRefesh } from 'src/store/app-slice';
import { useServerError } from './use-server-error';

export const useBookingRequestAction = () => {
  const dispatch = useDispatch();
  const { processError } = useServerError();

  const [confirmBookingRequest] = useConfirmBookingRequestMutation();
  const [assignBookingRequest] = useAssignBookingRequestMutation();

  const debounceHandleConfirm = useCallback(
    debounce(async (id, accept) => {
      dispatch(
        setRefesh({
          [refreshKeyConfig.pageLoading]: getTime(new Date())
        })
      );
      try {
        await confirmBookingRequest({ id, isAccept: accept }).unwrap();
        if (accept === true) {
          toast.success(`Yêu cầu nhận kèo đã được gửi.`, {
            id: 'unique-toast-id',
            ariaProps: {
              'aria-live': 'assertive'
            },
            duration: 1000 // Toast sẽ tự động biến mất sau 3 giây
          });
        }
      } catch (error) {
        processError(error);
      } finally {
        dispatch(
          setRefesh({
            [refreshKeyConfig.pageLoading]: false
          })
        );
      }
    }, 200),
    []
  );

  const debounceHandleAssign = useCallback(
    debounce(async (params) => {
      dispatch(
        setRefesh({
          [refreshKeyConfig.pageLoading]: getTime(new Date())
        })
      );
      try {
        await assignBookingRequest(params).unwrap();

        toast.success(`Thông tin xác nhận đã gửi đến nhà xe.`);
      } catch (error) {
        processError(error);
      } finally {
        dispatch(
          setRefesh({
            [refreshKeyConfig.pageLoading]: false
          })
        );
      }
    }, 200),
    []
  );

  return {
    handleConfirm: debounceHandleConfirm,
    handleAssign: debounceHandleAssign
  };
};
